import gestionApiService from '@/core/services/gestionApiService.ts'
import {
  Rentability,
  RentabilityResponse
} from '@/modules/settings/tasa/types/types.ts'

export default class rentabilityService {
  static async getRentabilities(filters: string): Promise<RentabilityResponse> {
    return gestionApiService.httpGET<RentabilityResponse>(
      `/rentabilities${filters ? filters : ''}`
    )
  }

  static async createRentability(rentability: Rentability) {
    return gestionApiService.httpPOST(`/rentabilities`, rentability)
  }

  static async updateRentability(rentability: Rentability) {
    const payload = {
      quotes: rentability.quotes,
      exchange: rentability.exchange,
      timesQuotes: rentability.timesQuotes,
      type: rentability.type
    }
    return gestionApiService.httpPUT(
      `/rentabilities/${rentability.id}`,
      payload
    )
  }

  static async setDefaultRentability(id: string) {
    return gestionApiService.httpPUT(`rentabilities/${id}/set-default`, {})
  }

  static async deleteRentability(id: string) {
    return gestionApiService.httpDELETE(`/rentabilities/${id}`)
  }
}
